export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7774.27899bdb.jpg";